import React from 'react';
import api from '../../../helpers/api';
import styles from './Parameters.module.scss';
import Loader from '../../../components/miscellaneous/Loader/Loader';
import Tooltip from '../../../components/miscellaneous/Tooltip/Tooltip';
import { $t } from '../../../helpers/translator';
import { VscError } from "react-icons/vsc";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import _ from "lodash";
import {setAlert} from "../../../store/alerts-slice";
import {connect} from "react-redux";

class ClinicTreatmentParameters extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editable: false,

            treatmentParametersShrStack: null,
            treatmentParametersShr: null,

            expanded: {
                handleQuatro: false,
                handle150: false,
                handle350: false,
            }
        };
    }

    async componentDidMount() {
        await this.getData()
    }

    async getData() {
        try {
            let clinic = await api.get('/account/clinic');
            if (clinic && clinic.data) {
                //parameters are only editable if no parent clinic exists:
                this.setState({editable: !clinic.data.parent_clinic})
            }

            // let res = await api.getHandleParameters('handle150');
            let res = await api.get('/grids/handle150');
            if (res && res.data && res.data.data) {
                this.setHandleRowsHandle150(res.data.data);
            }

            // let res2 = await api.getHandleParameters('handle300');
            let res2 = await api.get('/grids/handle300');
            if (res2 && res2.data && res2.data.data) {
                this.setHandleRowsHandle300(res2.data.data);
            }

            // let res3 = await api.getHandleParameters('quatro');
            let res3 = await api.get('/grids/quatro');
            if (res3 && res3.data && res3.data.data) {
                this.setHandleRowsQuatro(res3.data.data);
            }

        } catch (e) {
            console.error('err getting dt', e);
        }
    }

    /**
     * function turns all rows received for quatro into smaller table
     * removes lines and adds for each cell it's dependencies: cells
     * in the original table that should also be edited.
     * @param data: raw data from server
     */
    setHandleRowsQuatro(data) {
        //shr:
        let handleQuatro = {
            grids: [[], [], [], []],
            gridsStack: Array(12),
        };

        _.forEach(data.grids, (v, k) => {
            v.limits = {
                fluence: [2, 10],
                energy600: [2, 26],
                energy700: [2, 30],
                energy800: [2, 32],
                energy900: [2, 36],
            };
            v.errors = {
                fluence: '',
                energy600: '',
                energy700: '',
                energy800: '',
                energy900: '',
            };

            if (v.hair_type === 1 && (v.skin_type === 1 || v.skin_type === 2 || v.skin_type === 3)) {
                handleQuatro.grids[0].push(v);
            }
            if (v.hair_type === 2 && (v.skin_type === 1 || v.skin_type === 2 || v.skin_type === 3)) {
                handleQuatro.grids[1].push(v);
            }
            if (v.hair_type === 1 && (v.skin_type === 4 || v.skin_type === 5 || v.skin_type === 6)) {
                handleQuatro.grids[2].push(v);
            }
            if (v.hair_type === 2 && (v.skin_type === 4 || v.skin_type === 5 || v.skin_type === 6)) {
                handleQuatro.grids[3].push(v);
            }
        });

        _.forEach(data.gridsStack, (v, k) => {
            v.limits = {
                fluence: [2, 10],
                energy: [2, 32],
                mode: [1, 4]
            };
            v.errors = {
                fluence: '',
                energy: '',
                mode: ''
            };
            //calculating row number in array for display:
            //calculation is based on
            let rowNumber = 4 * (v.size / 25 - 1) + 2 * Math.floor(v.skin_type / 4) + (v.hair_type - 1);
            // console.log('vv vv: ['+v.rowNumber+']  size=', v.size, 4*(v.size / 25 -1), ' skin=', v.skin_type, Math.floor(v.skin_type/4), ' hair=', v.hair_type, v.hair_type -1)
            if (!handleQuatro.gridsStack[rowNumber]) {
                handleQuatro.gridsStack[rowNumber] = [];
            }
            handleQuatro.gridsStack[rowNumber].push(v);
        });

        this.setState({ handleQuatro: handleQuatro });
    }

    setHandleRowsHandle150(data) {
        let handleData = {
            grids: [[], []],
            gridsStack: [[], []],
        };
        // console.log('setHandleRowsHandle150', data);

        _.forEach(data.grids, (v, k) => {
            v.limits = {
                fluence: [2, 20],
                energy: [2, 32]
            };
            v.errors = {
                fluence: '',
                energy: '',
            };

            if (v.hair_type === 1 && (v.skin_type === 1 || v.skin_type === 2 || v.skin_type === 3)) {
                handleData.grids[0].push(v);
            } else if (v.hair_type === 2 && (v.skin_type === 1 || v.skin_type === 2 || v.skin_type === 3)) {
                handleData.grids[1].push(v);
            } else {
                handleData.grids.push([v]);
            }
        });
        _.forEach(data.gridsStack, (v, k) => {
            v.limits = {
                fluence: [2, 20],
                mode: [1, 4],
                passes: [0, 9]
            };
            v.errors = {
                fluence: '',
                mode: '',
                passes: ''
            };
            // console.log('150vr', v);
            if (v.hair_type === 1 && (v.skin_type === 1 || v.skin_type === 2)) {
                handleData.gridsStack[0].push(v);
            } else if (v.hair_type === 2 && (v.skin_type === 1 || v.skin_type === 2)) {
                handleData.gridsStack[1].push(v);
            } else {
                handleData.gridsStack.push([v]);
            }
        });
        this.setState({ handle150: handleData });
    }

    setHandleRowsHandle300(data) {
        let handleData = {
            grids: [[], []],
            gridsStack: [[], []],
        };
        // console.log('setHandleRowsHandle150', data);

        _.forEach(data.grids, (v, k) => {
            v.limits = {
                fluence: [2, 20],
                energy: [2, 32]
            };
            v.errors = {
                fluence: '',
                energy: '',
            };

            if (v.hair_type === 1 && (v.skin_type === 1 || v.skin_type === 2 || v.skin_type === 3)) {
                handleData.grids[0].push(v);
            } else if (v.hair_type === 2 && (v.skin_type === 1 || v.skin_type === 2 || v.skin_type === 3)) {
                handleData.grids[1].push(v);
            } else {
                handleData.grids.push([v]);
            }
        });
        _.forEach(data.gridsStack, (v, k) => {
            v.limits = {
                fluence: [2, 20],
                mode: [1, 4],
                passes: [0, 9]
            };
            v.errors = {
                fluence: '',
                mode: '',
                passes: '',
            };
            // console.log('150vr', v);
            if (v.hair_type === 1 && (v.skin_type === 1 || v.skin_type === 2)) {
                handleData.gridsStack[0].push(v);
            } else if (v.hair_type === 2 && (v.skin_type === 1 || v.skin_type === 2)) {
                handleData.gridsStack[1].push(v);
            } else {
                handleData.gridsStack.push([v]);
            }
        });
        this.setState({ handle300: handleData });
    }


    valueChange(e) {
        let state = { ...this.state };
        let valPointer = state;

        let path = e.target.name.split('.');

        for (let i = 0; i < path.length - 1; i++) {
            valPointer = valPointer[path[i]];   //after loop, valPointer points to array of values to be changed
        }
        let value = e.target.value;


        let limits = valPointer[0].limits[path[path.length - 1]] ? valPointer[0].limits[path[path.length - 1]] : null;
        let validationRes = this.validateValue(path[path.length - 1], e.target.value, limits);


        _.forEach(valPointer, (v, k) => {
            // console.log('valvalv', v, path, validationRes);
            v.errors[path[path.length - 1]] = validationRes.error;
            v[path[path.length - 1]] = value && !isNaN(parseInt(value)) ? parseInt(value) : '';
        });
        this.setState(state, async () => {
            // console.log(this.state);

            let isRowValidated = true;
            _.forEach(valPointer[0].errors, (v, k) => {
                if (v) {
                    isRowValidated = false;
                }
            });
            // console.log('isRowValidated', isRowValidated);
            if (isRowValidated) {
                try {
                    // let res = await api.setHandleParameters({
                    //     [path[1]]: valPointer
                    // });
                    let res = await api.patch('/grids', {
                        [path[1]]: valPointer
                    });
                    this.props.dispatch(setAlert({type: 'success'}));
                } catch (e) {
                    console.error('err updating val', e);
                    this.props.dispatch(setAlert({type: 'error'}));
                }

            }

        });
    }

    validateValue(name, value, limits) {
        // console.log('validationResBefore', name, value, limits);
        let res = {
            valid: true,
            error: '',
            field: name
        };

        if (limits && limits[0] && parseInt(value) < limits[0]) {
            res.valid = false;
            res.error = $t('validation.general.range', [limits[0], limits[1]]);
        }
        if (limits && limits[1] && parseInt(value) > limits[1]) {
            res.valid = false;
            res.error = $t('validation.general.range', [limits[0], limits[1]]);
        }

        if (value.length === 0 || !(/^\d+$/.test(value))) {
            res.valid = false;
            res.error = $t('validation.general.required');
        }

        return res;
    }

    renderHandleQuatroData() {
        let shrRows = [];
        let shrStackRows = [];
        let data = { ...this.state.handleQuatro };

        let counter = 0;
        _.forEach(data.grids, (v, k) => {
            let rowError = '';
            _.forEach(this.state.handleQuatro.grids[k][0].errors, (va,ka) => {
                if (va) {
                    rowError += '  '+ka+': '+ va + '.   ';
                }
            })
            // console.log('>>', rowError, rowError.length)

            let row = <tr key={k}>
                {counter % 2 ?
                    null
                    :
                    <td rowSpan="2">{v[0].skin_type === 1 ? '1-3' : '4-6'}</td>}
                <td>{v[0].hair_type === 1 ? $t('global.parameters.sparse') : $t('global.parameters.coarse')}</td>
                <td>
                    {/*<Tooltip content={this.state.handleQuatro.grids[k][0].errors.fluence} isOpen={this.state.handleQuatro.grids[k][0].errors.fluence} >*/}
                    <input name={'handleQuatro.grids.' + k + '.fluence'}
                           className={`${styles['input']} ${styles[(this.state.handleQuatro.grids[k][0].errors.fluence ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handleQuatro.grids[k][0].fluence}
                           onChange={(e) => this.valueChange(e)}
                    />
                    {/*</Tooltip>*/}
                </td>
                <td>
                    <input name={'handleQuatro.grids.' + k + '.energy600'}
                           className={`${styles['input']} ${styles[(this.state.handleQuatro.grids[k][0].errors.energy600 ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handleQuatro.grids[k][0].energy600}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <input name={'handleQuatro.grids.' + k + '.energy700'}
                           className={`${styles['input']} ${styles[(this.state.handleQuatro.grids[k][0].errors.energy700 ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handleQuatro.grids[k][0].energy700}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <input name={'handleQuatro.grids.' + k + '.energy800'}
                           className={`${styles['input']} ${styles[(this.state.handleQuatro.grids[k][0].errors.energy800 ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handleQuatro.grids[k][0].energy800}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <input name={'handleQuatro.grids.' + k + '.energy900'}
                           className={`${styles['input']} ${styles[(this.state.handleQuatro.grids[k][0].errors.energy900 ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handleQuatro.grids[k][0].energy900}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <div className={`${styles[(rowError && rowError.length ? 'row-error-indicator' : 'display-none')]}` }>
                        <Tooltip content={rowError}>
                            <VscError className={`${styles['err-icon']}` } />
                        </Tooltip>
                    </div>
                </td>

            </tr>;
            shrRows.push(row);
            counter++;
        });

        counter = 0;
        _.forEach(data.gridsStack, (v, k) => {
            let rowError = '';
            _.forEach(this.state.handleQuatro.gridsStack[k][0].errors, (va,ka) => {
                if (va) {
                    rowError += '  '+ka+': '+ va + '.   ';
                }
            })

            let row = <tr key={k}>
                {counter % 4 ?
                    null
                    :
                    <td rowSpan="4">{v[0].size}</td>
                }
                {counter % 2 ?
                    null
                    :
                    <td rowSpan="2">{v[0].skin_type === 1 ? '1-3' : '4-6'}</td>
                }
                <td>{v[0].hair_type === 1 ? $t('global.parameters.sparse') : $t('global.parameters.coarse')}</td>
                <td>
                    <input name={'handleQuatro.gridsStack.' + k + '.fluence'}
                           className={`${styles['input']} ${styles[(this.state.handleQuatro.gridsStack[k][0].errors.fluence ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handleQuatro.gridsStack[k][0].fluence}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <input name={'handleQuatro.gridsStack.' + k + '.mode'}
                           className={`${styles['input']} ${styles[(this.state.handleQuatro.gridsStack[k][0].errors.mode ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handleQuatro.gridsStack[k][0].mode}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <input name={'handleQuatro.gridsStack.' + k + '.energy'}
                           className={`${styles['input']} ${styles[(this.state.handleQuatro.gridsStack[k][0].errors.energy ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handleQuatro.gridsStack[k][0].energy}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>

                <td>
                    <div className={`${styles[(rowError && rowError.length ? 'row-error-indicator' : 'display-none')]}` }>
                        <Tooltip content={rowError}>
                            <VscError className={`${styles['err-icon']}` } />
                        </Tooltip>
                    </div>
                </td>
            </tr>;
            shrStackRows.push(row);
            counter++;
        });


        return (
            <div>
                {/*<div className={`${styles['sub-content']}` }>working on <span className={`${styles['bold']}` }> 600cm<sup>2</sup></span> as default*/}
                {/*</div>*/}

                <div className={`${styles['sub-content']}` }>
                    {$t('global.parameters.defaultWorkState')}: <span className={`${styles['bold']}` }> 600cm<sup>2</sup></span>
                </div>
                <div className={`${styles['row']}` }>
                    <div className={`${styles['sub-content']}` }>
                        <div className={`${styles['sub-header']}` }>{$t('global.parameters.shr')}</div>
                        <div className={`${styles['table-container']}` }>
                        <table>
                            <tbody>
                            <tr>
                                {/*<td>Area</td>*/}
                                <td>{$t('global.parameters.skinType')}</td>
                                <td>{$t('global.parameters.hairDensity')}</td>
                                <td>{$t('global.parameters.fluence')}</td>
                                <td>{$t('global.parameters.totalEnergyWithRange', ['0-650'])}</td>
                                <td>{$t('global.parameters.totalEnergyWithRange', ['650-750'])}</td>
                                <td>{$t('global.parameters.totalEnergyWithRange', ['750-850'])}</td>
                                <td>{$t('global.parameters.totalEnergyWithRange', ['850-950'])}</td>
                            </tr>
                            {shrRows}
                            </tbody>
                        </table>
                        </div>
                    </div>
                    {/*</div>*/}
                    {/*<div className={`${styles['row']}` }>*/}

                    <div className={`${styles['sub-content']}` }>
                        <div className={`${styles['sub-header']}` }>{$t('global.parameters.shrStack')}</div>
                        <div className={`${styles['table-container']}` }>
                            <table>
                                <tbody>
                        <tr>
                            <td>{$t('global.parameters.areaSize')}</td>
                            <td>{$t('global.parameters.skinType')}</td>
                            <td>{$t('global.parameters.hairDensity')}</td>
                            <td>{$t('global.parameters.fluence')}</td>
                            <td>{$t('global.parameters.stackMode')}</td>
                            <td>{$t('global.parameters.energy')}</td>
                        </tr>
                        {shrStackRows}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderHandle150Data() {
        let shrRows = [];
        let shrStackRows = [];
        let data = { ...this.state.handle150 };

        let counter = 0;

        _.forEach(data.grids, (v, k) => {
            let rowError = '';
            _.forEach(this.state.handle150.grids[k][0].errors, (va,ka) => {
                if (va) {
                    rowError += '  '+ka+': '+ va + '.   ';
                }
            })

            let row = <tr key={k}>
                {counter % 2 ? null : <td rowSpan={'2'}>{v[0].skin_type === 1 ? '1-3' : v[0].skin_type}</td>}
                <td>{v[0].hair_type === 1 ? $t('global.parameters.sparse') : $t('global.parameters.coarse')}</td>
                <td>
                    <input name={'handle150.grids.' + k + '.fluence'}
                           className={`${styles['input']} ${styles[(this.state.handle150.grids[k][0].errors.fluence ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handle150.grids[k][0].fluence}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <input name={'handle150.grids.' + k + '.energy'}
                           className={`${styles['input']} ${styles[(this.state.handle150.grids[k][0].errors.energy ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handle150.grids[k][0].energy}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <div className={`${styles[(rowError && rowError.length ? 'row-error-indicator' : 'display-none')]}` }>
                        <Tooltip content={rowError}>
                            <VscError className={`${styles['err-icon']}` } />
                        </Tooltip>
                    </div>
                </td>
            </tr>;
            shrRows.push(row);
            counter++;
        });

        counter = 0;
        _.forEach(data.gridsStack, (v, k) => {
            let rowError = '';
            _.forEach(this.state.handle150.gridsStack[k][0].errors, (va,ka) => {
                if (va) {
                    rowError += '  '+ka+': '+ va + '.   ';
                }
            })

            let row = <tr key={k}>
                {counter % 2 ? null : <td rowSpan={'2'}>{v[0].skin_type === 1 ? '1-2' : v[0].skin_type}</td>}
                <td>{v[0].hair_type === 1 ? $t('global.parameters.sparse') : $t('global.parameters.coarse')}</td>
                <td>
                    <input name={'handle150.gridsStack.' + k + '.fluence'}
                           className={`${styles['input']} ${styles[(this.state.handle150.gridsStack[k][0].errors.fluence ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handle150.gridsStack[k][0].fluence}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <input name={'handle150.gridsStack.' + k + '.mode'}
                           className={`${styles['input']} ${styles[(this.state.handle150.gridsStack[k][0].errors.mode ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handle150.gridsStack[k][0].mode}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <input name={'handle150.gridsStack.' + k + '.passes'}
                           className={`${styles['input']} ${styles[(this.state.handle150.gridsStack[k][0].errors.passes ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handle150.gridsStack[k][0].passes}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <div className={`${styles[(rowError && rowError.length ? 'row-error-indicator' : 'display-none')]}` }>
                        <Tooltip content={rowError}>
                            <VscError className={`${styles['err-icon']}` } />
                        </Tooltip>
                    </div>
                </td>
            </tr>;
            shrStackRows.push(row);
            counter++;
        });

        return (
            <div>
                <div className={`${styles['sub-content']}` }>
                    {$t('global.parameters.defaultWorkState')}: <span className={`${styles['bold']}` }> 150cm<sup>2</sup></span>
                </div>

                <div className={`${styles['row']}` }>
                    <div className={`${styles['sub-content']}` }>
                        <div className={`${styles['sub-header']}` }>{$t('global.parameters.shr')}</div>
                        <div className={`${styles['table-container']}` }>
                        <table>
                            <tbody>
                            <tr>
                                {/*<td>Area</td>*/}
                                <td>{$t('global.parameters.skinType')}</td>
                                <td>{$t('global.parameters.hairDensity')}</td>
                                <td>{$t('global.parameters.fluence')}</td>
                                <td>{$t('global.parameters.energy')}</td>
                            </tr>
                            {shrRows}
                            </tbody>
                        </table>
                        </div>
                    </div>
                    <div className={`${styles['sub-content']}` }>
                        <div className={`${styles['sub-header']}` }>{$t('global.parameters.shrStack')}</div>
                        <div className={`${styles['table-container']}` }>
                        <table>
                            <tbody>
                            <tr>
                                {/*<td>Area</td>*/}
                                <td>{$t('global.parameters.skinType')}</td>
                                <td>{$t('global.parameters.hairDensity')}</td>
                                <td>{$t('global.parameters.fluence')}</td>
                                <td>{$t('global.parameters.stackMode')}</td>
                                <td>{$t('global.parameters.numberOfPasses')}</td>
                            </tr>
                            {shrStackRows}
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>

            </div>
        );
    }

    renderHandle300Data() {
        let shrRows = [];
        let shrStackRows = [];
        let data = { ...this.state.handle300 };

        let counter = 0;

        _.forEach(data.grids, (v, k) => {
            let rowError = '';
            _.forEach(this.state.handle300.grids[k][0].errors, (va,ka) => {
                if (va) {
                    rowError += '  '+ka+': '+ va + '.   ';
                }
            })

            let row = <tr key={k}>
                {counter % 2 ? null : <td rowSpan={'2'}>{v[0].skin_type === 1 ? '1-3' : v[0].skin_type}</td>}
                <td>{v[0].hair_type === 1 ? $t('global.parameters.sparse') : $t('global.parameters.coarse')}</td>
                <td>
                    <input name={'handle300.grids.' + k + '.fluence'}
                           className={`${styles['input']} ${styles[(this.state.handle300.grids[k][0].errors.fluence ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handle300.grids[k][0].fluence}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <input name={'handle300.grids.' + k + '.energy'}
                           className={`${styles['input']} ${styles[(this.state.handle300.grids[k][0].errors.energy ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handle300.grids[k][0].energy}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <div className={`${styles[(rowError && rowError.length ? 'row-error-indicator' : 'display-none')]}` }>
                        <Tooltip content={rowError}>
                            <VscError className={`${styles['err-icon']}` } />
                        </Tooltip>
                    </div>
                </td>
            </tr>;
            shrRows.push(row);
            counter++;
        });
        counter = 0;
        _.forEach(data.gridsStack, (v, k) => {
            let rowError = '';
            _.forEach(this.state.handle300.gridsStack[k][0].errors, (va,ka) => {
                if (va) {
                    rowError += '  '+ka+': '+ va + '.   ';
                }
            })
            // console.log('rowerror', rowError)

            let row = <tr key={k}>
                {counter % 2 ? null : <td rowSpan={'2'}>{v[0].skin_type === 1 ? '1-2' : v[0].skin_type}</td>}
                <td>{v[0].hair_type === 1 ? $t('global.parameters.sparse') : $t('global.parameters.coarse')}</td>
                <td>
                    <input name={'handle300.gridsStack.' + k + '.fluence'}
                           className={`${styles['input']} ${styles[(this.state.handle300.gridsStack[k][0].errors.fluence ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handle300.gridsStack[k][0].fluence}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <input name={'handle300.gridsStack.' + k + '.mode'}
                           className={`${styles['input']} ${styles[(this.state.handle300.gridsStack[k][0].errors.mode ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handle300.gridsStack[k][0].mode}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <input name={'handle300.gridsStack.' + k + '.passes'}
                           className={`${styles['input']} ${styles[(this.state.handle300.gridsStack[k][0].errors.passes ? 'input-error' : '')]}`}
                           type="tel"
                           disabled={!this.state.editable}
                           value={this.state.handle300.gridsStack[k][0].passes}
                           onChange={(e) => this.valueChange(e)}
                    />
                </td>
                <td>
                    <div className={`${styles[(rowError && rowError.length ? 'row-error-indicator' : 'display-none')]}` }>
                        <Tooltip content={rowError}>
                            <VscError className={`${styles['err-icon']}` } />
                        </Tooltip>
                    </div>
                </td>
            </tr>;
            shrStackRows.push(row);
            counter++;
        });

        return (
            <div>
                <div className={`${styles['sub-content']}` }>
                    <div>
                        <span className={`${styles['bold']}` }>Alex (1.5 cm<sup>2</sup>)</span> - {$t('global.parameters.defaultWorkState')}: <span className={`${styles['bold']}` }> 600cm<sup>2</sup></span>
                    </div>

                    <div>
                        <span className={`${styles['bold']}` }>Speed/Trio (2 cm<sup>2</sup>)</span> - {$t('global.parameters.defaultWorkState')}: <span className={`${styles['bold']}` }> 600cm<sup>2</sup></span>
                    </div>
                </div>

                <div className={`${styles['row']}`}>
                    <div className={`${styles['sub-content']}` }>
                        <div className={`${styles['sub-header']}` }>{$t('global.parameters.shr')}</div>
                        <div className={`${styles['table-container']}` }>
                            <table>
                                <tbody>
                                <tr>
                                    {/*<td>Area</td>*/}
                                    <td>{$t('global.parameters.skinType')}</td>
                                    <td>{$t('global.parameters.hairDensity')}</td>
                                    <td>{$t('global.parameters.fluence')}</td>
                                    <td>{$t('global.parameters.energy')}</td>
                                </tr>
                                {shrRows}
                                </tbody>
                            </table>
                        </div>

                    </div>
                    <div className={`${styles['sub-content']}` }>
                        <div className={`${styles['sub-header']}` }>{$t('global.parameters.shrStack')}</div>
                        <div className={`${styles['table-container']}` }>
                        <table>
                            <tbody>
                            <tr>
                                {/*<td>Area</td>*/}
                                <td>{$t('global.parameters.skinType')}</td>
                                <td>{$t('global.parameters.hairDensity')}</td>
                                <td>{$t('global.parameters.fluence')}</td>
                                <td>{$t('global.parameters.stackMode')}</td>
                                <td>{$t('global.parameters.numberOfPasses')}</td>
                            </tr>
                            {shrStackRows}
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    toggleHandleExpand(handle) {
        let expanded = { ...this.state.expanded };
        expanded[handle] = !expanded[handle];
        this.setState({ expanded: expanded });
    }


    render() {

        return (
            <div>
                <div className={`${styles['container']}` }>
                    <div>

                        <div className={`alma-box ${styles['container']}` }>
                            <div className={'alma-box-header'} >
                                <h3>{$t('global.parameters.areaSettingsForApplicators')}</h3>
                            </div>
                            <div>

                                    <div className={`${styles['applicator-info']}` }>
                                        <span className={`${styles['bold']}` }>Compact (1cm<sup>2</sup>)</span> - {$t('global.parameters.defaultWorkState')}: <span className={`${styles['bold']}` }> 150cm<sup>2</sup></span>
                                    </div>
                                    <div className={`${styles['applicator-info']}` }>
                                        <span className={`${styles['bold']}` }>Alex (1.5 cm<sup>2</sup>)</span> - {$t('global.parameters.defaultWorkState')}: <span className={`${styles['bold']}` }> 300cm<sup>2</sup></span>
                                    </div>

                                    <div className={`${styles['applicator-info']}` }>
                                        <span className={`${styles['bold']}` }>Speed/Trio (2 cm<sup>2</sup>)</span> - {$t('global.parameters.defaultWorkState')}: <span className={`${styles['bold']}` }> 300cm<sup>2</sup></span>
                                    </div>
                                    <div className={`${styles['applicator-info']}` }>
                                        <span className={`${styles['bold']}` }>Trio (4cm<sup>2</sup>)</span> - {$t('global.parameters.defaultWorkState')}: <span className={`${styles['bold']}` }> 600cm<sup>2</sup></span>
                                    </div>

                            </div>
                        </div>

                        <div className={`alma-box ${styles['container']}` }>
                            <div className={`alma-box-header ${styles['pointer']} ${styles[(!this.state.expanded.handleQuatro ? 'no-border' : '')]}`} onClick={() => this.toggleHandleExpand('handleQuatro')}>
                                <h3>Trio (4cm<sup>2</sup>)</h3>
                                <div>
                                    {this.state.expanded.handleQuatro ?
                                        <IoChevronUp className={`${styles['icon-expand']}` }/>
                                        :
                                        <IoChevronDown className={`${styles['icon-expand']}` } />
                                    }
                                </div>
                            </div>
                            {this.state.expanded.handleQuatro ?
                                <div>
                                    {!this.state.handleQuatro ?
                                        <Loader/>
                                        :
                                        this.renderHandleQuatroData()
                                    }
                                </div>
                                : null}
                        </div>

                        <div className={`alma-box ${styles['container']}` }>
                            <div className={`alma-box-header ${styles['pointer']} ${styles[(!this.state.expanded.handle150 ? 'no-border' : '')]}`} onClick={() => this.toggleHandleExpand('handle150')}>
                                <h3>Compact (1cm<sup>2</sup>)</h3>
                                <div>
                                    {this.state.expanded.handle150 ?
                                        <IoChevronUp className={`${styles['icon-expand']}` } />
                                        :
                                        <IoChevronDown className={`${styles['icon-expand']}` } />
                                    }
                                </div>
                            </div>
                            {this.state.expanded.handle150 ?
                                <div>
                                    {!this.state.handle150 ?
                                        <Loader/>
                                        :
                                        this.renderHandle150Data()
                                        // null
                                    }
                                </div>
                                :
                                null}
                        </div>

                        <div className={`alma-box ${styles['container']}` }>
                            <div className={`alma-box-header ${styles['pointer']} ${styles[(!this.state.expanded.handle300 ? 'no-border' : '')]}`} onClick={() => this.toggleHandleExpand('handle300')}>
                                <h3>Speed/Trio (2cm<sup>2</sup>) and Alex (1.5cm<sup>2</sup>) </h3>
                                <div>
                                    {this.state.expanded.handle300 ?
                                        <IoChevronUp className={`${styles['icon-expand']}` } />
                                    :
                                        <IoChevronDown className={`${styles['icon-expand']}` } />
                                    }
                                </div>
                            </div>
                            {this.state.expanded.handle300 ?
                                <div>
                                    {!this.state.handle300 ?
                                        <Loader/>
                                        :
                                        this.renderHandle300Data()
                                    }
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

// export default ClinicTreatmentParameters;
const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(ClinicTreatmentParameters);
